import React from 'react';
import { useDispatch } from 'react-redux';
import { Image, ModalBody, ModalFooter } from '@chakra-ui/react';

import StackedButtonGroup from '../../../../components/Modal/ModalButtonGroups/StackedButtonGroup';
import { deleteJobAttachment } from '../../../../redux/modules/jobs';
import { hideModal } from '../../../../redux/modules/modal';

const DeleteAttachmentModal = ({ attachment }) => {
  const dispatch = useDispatch();

  return (
    <>
      <ModalBody>
        <Image src={attachment.largeThumbnailUrl} />
      </ModalBody>
      <ModalFooter>
        <StackedButtonGroup
          confirmLabel="Delete"
          onClick={async () => {
            await dispatch(deleteJobAttachment(attachment.id));
            dispatch(hideModal());
          }}
        />
      </ModalFooter>
    </>
  );
};

export default DeleteAttachmentModal;
